/*
 * @Author: Wang Wenmao
 * @Date: 2023-11-07 10:56:14
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2023-12-18 14:44:55
 * @Description: 商品参数展示
 */

import React, { useState, useEffect } from 'react';
import { Table, Button, Switch, Icon, Input, message } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';

const { api } = services;
const getHashPathParameter = () => {
    const hash = window.location.hash;
    const segments = hash.split('/');
    const param = segments[3];
    return param;
};

export const ProductInfoDetailAttributeList = () => {
    const columns = [
        {
            title: '属性名称',
            dataIndex: 'key',
            key: 'key',
        },
        {
            title: '属性类型',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: '品真阁属性名称',
            dataIndex: 'keyShowName',
            key: 'keyShowName',
            render: (name: string) => {
                return name ? (
                    <span>{name}</span>
                ) : (
                    <span style={{ color: 'rgba(0, 0, 0, 0.3)' }}>NA</span>
                );
            },
        },
        {
            title: '属性值',
            dataIndex: 'value',
            key: 'value',
        },
        {
            title: '品真阁属性值名称',
            key: 'valueShowName',
            dataIndex: 'valueShowName',
            render: (name: string, item: any, index: number) => {
                const { edit } = item;
                return edit ? (
                    <Input
                        style={{ width: '150px' }}
                        defaultValue={name}
                        placeholder="请输入"
                        onChange={({ target }) => handleChangeName(target.value, item)}
                    />
                ) : (
                    <span>{name}</span>
                );
            },
        },
        {
            title: '是否显示',
            dataIndex: 'status',
            key: 'status',
            render: (status: number, item: any) => (
                <Switch
                    checkedChildren={<Icon type="check" />}
                    unCheckedChildren={<Icon type="close" />}
                    defaultChecked={status === 0}
                    onChange={(checked) => handleChangeSwitch(checked, item)}
                />
            ),
        },
        {
            title: '操作',
            key: 'action',
            render: (_: any, item: any) => (
                <span>
                    {!item.edit ? (
                        <Button type="link" onClick={() => handleClickRowOps('edit', item)}>
                            编辑显示名称
                        </Button>
                    ) : (
                        <>
                            <Button type="link" onClick={() => handleClickRowOps('save', item)}>
                                保存
                            </Button>
                            <Button type="link" onClick={() => handleClickRowOps('delete', item)}>
                                取消
                            </Button>
                        </>
                    )}
                </span>
            ),
        },
    ];

    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => getAttrList(), []);

    // 获取表格数控
    const getAttrList = () => {
        const params = getHashPathParameter();
        if (!params) return;
        const apiPath = `/products/${params}/attributes`;
        setLoading(true);
        api.get({}, { apiPath })
            .then((res: any) => setDataSource(res))
            .catch(errorHandle)
            .finally(() => setLoading(false));
    };

    // 更新操作
    const updateSkuAttributes = (item: any) => {
        const params = getHashPathParameter();
        if (!params) return;

        const apiPath = `/products/${params}/updateSkuAttributes`;
        api.put(item, { apiPath })
            .then((res) => {
                if (!res) {
                    message.success('修改成功');
                } else {
                    message.error('修改失败');
                }
            })
            .catch(errorHandle)
            .finally(getAttrList);
    };

    const setItem = (id: number, key: string, value: any, cb?: Function) => {
        const newData = [...dataSource] as any;
        const index = newData.findIndex((item: any) => id === item.id);
        const currentData = newData[index];
        currentData[key] = value;
        setDataSource(newData);
        cb && cb();
    };

    // 操作行
    const handleClickRowOps = (type: string, item: any) => {
        const index = dataSource.findIndex((data: any) => data.id === item.id);
        const current: any = dataSource[index];
        if (type === 'edit') {
            setItem(item.id, 'edit', true);
            return;
        }

        if (type === 'save') {
            if (current.showNameCopy) {
                setItem(item.id, 'valueShowName', current.showNameCopy, () =>
                    updateSkuAttributes(current)
                );
            }
        } else {
            setItem(item.id, 'showNameCopy', '');
        }

        setItem(item.id, 'edit', false);
    };

    // 修改显示名称
    const handleChangeName = (value: string, item: any) => {
        setItem(item.id, 'showNameCopy', value);
    };

    // 修改是否显示
    const handleChangeSwitch = (checked: boolean, item: any) => {
        setItem(item.id, 'status', checked ? 0 : 1, () => updateSkuAttributes(item));
    };

    return <Table rowKey="id" columns={columns} dataSource={dataSource} loading={loading} />;
};
